// Shared configuration for volume pricing.
// Defines quantity breakpoints and order-level discount tiers.

window.theme = window.theme || {};

theme.volumePricingConfig = {
  /**
   * Fixed quantity tiers for the grid.
   * These are per-item quantities, not cart-level.
   */
  quantityTiers: [1, 10, 25, 50, 100],

  /**
   * Order-level discount tiers.
   * Thresholds are based on the line subtotal (base price × quantity), in cents.
   *
   * Example: minSubtotalCents: 50000 === $500.00 if store currency uses cents.
   */
  orderDiscountTiers: [
    {
      minSubtotalCents: 50000, // $500
      maxSubtotalCents: 99999, // $999.99
      discountPercent: 0.02
    },
    {
      minSubtotalCents: 100000, // $1,000
      maxSubtotalCents: 199999, // $1,999.99
      discountPercent: 0.05
    },
    {
      minSubtotalCents: 200000, // $2,000
      maxSubtotalCents: 499999, // $4,999.99
      discountPercent: 0.10
    },
    {
      minSubtotalCents: 500000, // $5,000+
      maxSubtotalCents: null,
      discountPercent: 0.15
    }
  ]
};
